import React from 'react';
import {Link, useParams} from 'react-router';

import BackLink from "../../components/BackLink";
import InfoBox from "../../components/passengerInformation/InfoBox";
import useTravelDocs from "../../hooks/useTravelDocs";
import DownloadButton from "../../components/pdf/DownloadButton";
import {getBackToDashboardText} from "../../utils/themeUtils";
import { Trans, useLingui } from '@lingui/react/macro';

function LuggageTag(props) {
    const {hash} = useParams();
    const {passengers, bookingData} = useTravelDocs(hash);

    const {t} = useLingui();

    if(bookingData.cabinAllocated === null) {
        return (
            <div className="container mx-auto mt-4">
                <p>
                    <span translate="no"><Trans id="loading">loading</Trans>...</span>
                </p>
            </div>
        )
    }

    if(bookingData.cabinAllocated === false) {
        return (
            <div className="container mx-auto mt-4">
                <p>
                    <Trans id="cabin_allocation_failed_text">Cabin allocation has not yet finished, please try again later.</Trans>
                </p>
            </div>
        )
    }

    if(bookingData.error) {
        return (
            <div className="container mx-auto mt-4">
                <p>
                    <Trans id="error_try_again">There has been an error, please try again later.</Trans>
                </p>
            </div>
        )
    }

    return (
        <div className="container mx-auto mt-4">
            {!hash && <BackLink to="/" text={getBackToDashboardText()} />}

            <div className="md:flex">
                <div className="w-full md:w-2/3 md:pr-4">
                    <h1>
                        <Trans id="luggage_tag">Luggage tag</Trans>
                    </h1>
                    <InfoBox
                        classes="mt-6 md:inline-block"
                        infoText={t({id: "need_to_attach_to_bags_before_arrival"})}
                    />


                    <div className="mt-4">
                        <p className="text-lg text-grey-darker">
                            <Trans id="luggage_tag_guideline">Please use the button below to download your luggage tag. Please print one for every item of lugagge and attach one to each item of luggage handle as per the instructions. You can print as many luggage tags as you require.</Trans>
                        </p>
                    </div>

                    <div className="mt-6">
                        <DownloadButton type="luggage"
                            bookingData={bookingData}
                            passengers={passengers}
                            label={t({id: "download_luggage_tag"})} />
                    </div>


                    <div className="mt-4 mb-12">
                        <Link className="hidden xl:block action-button action-button-enabled w-mobile"
                              to={{
                                  pathname: t({id: "/luggage/detail"}),
                              }}
                              state= {{
                                passengers,
                                bookingData
                            }}
                        >
                            <Trans id="view_luggage_tag">View luggage tag</Trans>
                        </Link>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default LuggageTag;

